// Libraries
import { useApolloClient } from "@apollo/client";
import { Avatar, chakra, MenuItem, Stack } from "@chakra-ui/react";
import Cookie from "js-cookie";
import React from "react";
import { useGoogleLogout } from "react-google-login";
// import { useRouter } from 'next/router'
// Recoil
import { useSetRecoilState } from "recoil";
import { authData } from "../../../State";
// Components
import CollapseButton from "../CollapseButton";
import CustomMenu from "../CustomMenu";

interface userData {
  name: string;
}

const ProfileOptions = ({ name }: userData) => {
  //  const router = useRouter();

  // recoil
  const setAuthValue = useSetRecoilState(authData);

  const clientId = "540878263087-vib1pfgotojd3rkp73tob067d3mj534f.apps.googleusercontent.com";
  const client = useApolloClient();
  // const token = Cookie.get('x-auth-token');
  const type = Cookie.get("x-auth-type");

  //==================== Logout =========================
  const removeToken = async () => {
    await Cookie.remove("x-auth-token");
    await Cookie.remove("x-auth-student");
    await Cookie.remove("x-auth-type");

    // router.push("/login");
    if (typeof window !== "undefined") {
      // window.location.href = "/login";
      setAuthValue({
        loggedIn: false,
        studentData: {},
      });
      window.location.href = "/login";
      //  router.push("/login");
      // window.location.assign("/login");
    }
  };

  // Callback function for google
  const onLogoutSuccess = async () => {
    removeToken();
    client.clearStore();
    return;
  };

  // const onFailure = () => {
  //   console.log(message)
  // }

  // Google logout, clientId is our own personal google id and onLogoutSuccess is the callback function above
  const { signOut } = useGoogleLogout({
    clientId,
    onLogoutSuccess,
    // onFailure
  });

  const logoutHandler = () => {
    if (type === "email") {
      removeToken();
    }

    if (type === "google") {
      signOut();
      removeToken();
      client.clearStore();
    }
  };
  // ======================================================

  return (
    <CustomMenu
      menuHeader={
        <CollapseButton
          isTrunc={true}
          text="Profile"
          show={true}
          textSize="18px"
          icon={<Avatar name={name} borderColor="#fff" borderWidth={2} textColor="white" fontWeight="700" />}
        />
      }
      menuOptions={
        <>
          <Stack py={2} px={2}>
            <chakra.p color="gray.500" fontWeight="600">
              {name}
            </chakra.p>
          </Stack>
          <MenuItem
            borderRadius="sm"
            p={3}
            fontWeight="700"
            color="gray.600"
            cursor="pointer"
            _hover={{ bg: "gray.200" }}
            onClick={() => logoutHandler()}>
            Log Out
          </MenuItem>
        </>
      }
    />
  );
};

export default ProfileOptions;

// <Popover placement="top-start">
//   <PopoverTrigger>
//     <Box w="100%" userSelect="none">
//       <CollapseButton
//         isTrunc={true}
//         text={name}
//         show={true}
//         icon={
//           <Avatar
//             name={name}
//             borderRadius={12}
//             borderColor="#fff"
//             borderWidth={2}
//             textColor="white"
//             fontWeight="700"
//           />
//         }
//       />
//     </Box>
//   </PopoverTrigger>
//   <PopoverContent
//     zIndex={4}
//     bg="white"
//     borderColor="gray.400"
//     borderWidth={0}
//     width={"73%"}
//     _focus={{ borderColor: "#fff", borderWidth: 0, outline: "none" }}
//     boxShadow="0px 4px 5px rgba(0, 0, 0, 0.3), 0px 0px 4px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.3)"
//   >
//     <PopoverArrow />
//     <PopoverBody>
//       <List styleType="none" spacing={3} py={3} pl={6}>
//         <ListItem onClick={() => logoutHandler()} cursor="pointer" fontWeight="700" color="gray.500">
//           Logout
//         </ListItem>
//       </List>
//     </PopoverBody>
//   </PopoverContent>
// </Popover>
